/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ObsoleteVehicle } from '../models/obsolete-vehicle.model';
import { ConfigService } from './config.service';
import { RemoveObsoleteRecordsService } from './remove-obsolete-records.service';

@Injectable({
  providedIn: 'root'
})
export class RemoveObsoleteVehicleService implements RemoveObsoleteRecordsService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  getObsoleteRecords(): Observable<ObsoleteVehicle[]> {
    return this.http.get<ObsoleteVehicle[]>(`${this.configService.baseApiUrl}manage-gfs-vehicles/remove-obsolete-vehicles`).pipe(
      map((res) => res, catchError(myError => RemoveObsoleteVehicleService.handleError(myError))));
  }

  removeObsoleteRecords(): Observable<any> {
    return this.http.delete(`${this.configService.baseApiUrl}manage-gfs-vehicles/remove-obsolete-vehicles`)
    .pipe(catchError(myError => RemoveObsoleteVehicleService.handleError(myError)));
  }

  private static handleError(errorResponse: HttpErrorResponse): any {
    let errorMessage = 'An unexpected error occurred';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        } else {
          errorMessage = 'Remove Obsolete Vehicles failed.';
        }
        break;
      }
      case HttpStatusCode.Forbidden: {
        errorMessage = 'Unable to remove Obsolete Vehicles.';
        break;
      }
    }
    return throwError(errorMessage);
  }
}
